import FraudProtectionToken from "@/checkout/models/FraudProtectionToken"
import axios from "axios"

class FraudProtectionApi {
  private axiosInstance = axios.create({
    baseURL: `${process.env.VUE_APP_CHECKOUT_API}/ck/fraud-protection`,
  });

  async token(): Promise<FraudProtectionToken> {
    const { data } = await this.axiosInstance.get("/token")
    return new FraudProtectionToken(data)
  }
}

export default new FraudProtectionApi()
